<template>
  <div class="container product-section-main">
    <!-- <h1 class="text-center">{{data.name}}</h1> -->
    <div class="row my-4 product-list">
      <div
        class="col-md-3 col-6 pb-5"
        v-for="(product, i) in productParent"
        :key="i"
      >
        <div class="slide-box">
          <div class="product-box">
            <router-link
              :to="{
                name: 'detail',
                params: {
                  pro_id: product.id_product,
                  pro_url_key: product.url_key,
                },
                query: {
                  store: $route.query.store,
                  id: product.id_product,
                },
              }"
            >
              <!-- <div
            class="product_image"
            :style="{
              backgroundImage: `url(${product.image})`,
            }"
          ></div> -->
              <!-- <div class="product_image"> -->
              <img :src="product.image" class="new_product_image" alt="" />
              <!-- </div> -->
            </router-link>
            <div class="viewDetails">
               <router-link
              :to="{
                name: 'detail',
                params: {
                  pro_id: product.id_product,
                  pro_url_key: product.url_key,
                },
                query: {
                  store: $route.query.store,
                  id: product.id_product,
                },
              }"
            >
              <!-- <div
            class="product_image"
            :style="{
              backgroundImage: `url(${product.image})`,
            }"
          ></div> -->
              <!-- <div class="product_image"> -->
              View Detail
              <!-- </div> -->
            </router-link>
            </div>
          </div>
          <p>
            {{ product.name }}
          </p>
          <div class="price">
            <p> {{ product.selling_price | formatMoney }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="row my-4" >

        <div class="col-md-3" v-for="(product,i) in data.products" :key="i">
          <div class="store-grid-2 product-box">
          <img :src="product.image" class="img-fluid" alt="" />
        </div>  
          <p>
            <a href="#" class=" "> {{ product.name }} </a>
          </p>
          <div class="price">
            <p>Rs.{{ product.selling_price }}</p>
          </div>
        </div>

      </div> -->
</template>
<script>
export default {
  props: ["data"],
  computed : {
    productParent () {
      let obj = {products: []}
      if(this.data != undefined && this.data != null)
        obj = this.data
       return obj
    }
  }
};
</script>

